export const CHANGE_THEME = "CHANGE_THEME";
export const SET_THEME = "SET_THEME";
export const TURN_ON_SOUND = "TURN_ON_SOUND";
export const TURN_OFF_SOUND = "TURN_OFF_SOUND";
export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE";